import { render } from "./SpareParts.vue?vue&type=template&id=dd5c6576"
import script from "./SpareParts.vue?vue&type=script&lang=js"
export * from "./SpareParts.vue?vue&type=script&lang=js"

import "./SpareParts.vue?vue&type=style&index=0&id=dd5c6576&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__